import React from 'react'
import '../../stylings/aboutUsHome.css'
import { Link } from 'react-router-dom'

const AboutUs = () => {
    
    return (
        <div className='about-us-home container'>
            <div className="about-us-title">
                <span>Way, Truth and Life Foundation School</span>
                <h3 className='my-2'>Welcome</h3>
            </div>
            <p>At Way, Truth and Life Foundation School, we believe in nurturing young minds to their fullest potential, fostering a love for learning, and providing a dynamic environment where students can thrive academically, socially, and emotionally. Our commitment to excellence in education is reflected in our comprehensive curriculum, dedicated faculty, and vibrant school community.</p>
            <Link to='/about-school'><button>Read More</button></Link>
        </div>
    )
}

export default AboutUs
